import { render, staticRenderFns } from "./BlankChannelsComponent.vue?vue&type=template&id=b0be186a"
import script from "./BlankChannelsComponent.vue?vue&type=script&lang=js"
export * from "./BlankChannelsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports